import { render, staticRenderFns } from "./FilterCard.vue?vue&type=template&id=494accb2&scoped=true&"
import script from "./FilterCard.vue?vue&type=script&lang=js&"
export * from "./FilterCard.vue?vue&type=script&lang=js&"
import style0 from "./FilterCard.vue?vue&type=style&index=0&id=494accb2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494accb2",
  null
  
)

export default component.exports